import * as React from 'react';
export const doolaSvg = React.forwardRef(function doolaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#FEF4CC',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      fillRule: 'evenodd',
      clipRule: 'evenodd',
      d: 'M14.6 4.009c.867.065 1.488.447 1.783 1.145.184.438.195.973.094 1.496l-3.678 18.92c-.058.523.094.745.497.775.007 0 .351.023.61-.343-.135.684-1.224 1.909-2.965 1.778-.867-.065-1.489-.447-1.784-1.145-.184-.438-.194-.974-.092-1.497L12.7 6.478c.14-.712.008-1-.457-1.035-.01 0-.352-.02-.608.344.134-.684 1.223-1.908 2.964-1.778Zm6.438 0c.868.065 1.49.447 1.784 1.145.185.438.195.973.093 1.496l-3.677 18.92c-.058.523.094.745.497.775.012 0 .352.02.609-.343-.135.685-1.224 1.909-2.964 1.778-.867-.065-1.488-.447-1.783-1.145-.185-.438-.195-.974-.093-1.497l3.637-18.66c.14-.712.007-1-.457-1.035-.006 0-.35-.022-.609.344.135-.684 1.223-1.908 2.963-1.778Z',
      fill: '#F9C800',
    }),
  );
});
doolaSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var doola = {
  category: 'brand',
  colorable: false,
  name: 'doola',
  svg: doolaSvg,
};
